import Api from './Api'

export default {
  getUltravioletRays(lat, lon) {
    // return Api().get(`uvindex?lat=${lat}&lon=${lon}`)
    return Api().get(`uvindex`, {
      params: {
        lon: lon,
        lat: lat
      }
    })
  }
}
